class Login {

    constructor(){

        this.method     = ''; // Google, Facebook ou Site
        this.nome       = '';
        this.email      = '';
        this.id         = '';
        this.imagem     = '';

        this.create_sessao();
    }

    ok(data = {}){

        let temp = [];
        if(typeof(data.nome) !== 'undefined'){
            data = JSON.stringify(data);
            temp = (data.length) ? JSON.parse(data) : data;
        }else if(data.length){
            temp = JSON.parse(data);
        }else{
            temp = (data.length) ? JSON.parse(data) : data;
        }

        this.method     = temp.method;
        this.nome       = temp.nome;
        this.email      = temp.email;
        this.id         = temp.id;
        this.imagem     = temp.imagem;

        sessionStorage.setItem('login', true);
        sessionStorage.setItem('login_data', data);

        this.triggerInputs();
    }

    google(data){
        data['method'] = 'Google';
        this.ok(data);
    }
    facebook(data){
        data['method'] = 'Facebook';
        this.ok(data);
    }

    create_sessao(){

        if(sessionStorage.getItem('login') == null){
            sessionStorage.setItem('login', false);
            sessionStorage.setItem('login_data', {});
        }else if(sessionStorage.getItem('login') == 'true' && sessionStorage.getItem('login_data').length > 0){
            this.ok(sessionStorage.getItem('login_data'));
        }
    }

    triggerInputs(){

        if(document.getElementsByName('nome')){
            let a = document.getElementsByName('nome');
            for (let i = 0; i < a.length; i++) {
                a[i].value = this.nome ? this.nome : '';
            }
        }   

        if(document.getElementsByName('email')){
            let b = document.getElementsByName('email');
            for (let i = 0; i < b.length; i++) {
                b[i].value = this.email ? this.email : '';
            }
        }   
    }

    data(){
        let temp = {
            method: this.method,
            nome: this.nome,
            email: this.email,
            id: this.id,
            imagem: this.imagem,
        };

        return JSON.stringify(temp);
    }
    sync_backend(){

    }
}